export const NUMERIC_SEQUENCE_TEST_ROUTES = {
    ROOT: "/numeric-sequence",
    CREATE_TEST: "/numeric-sequence/create-test",
    CONSTRUCTOR: "/numeric-sequence/constructor",
    EDITING: "/numeric-sequence/editing/:id",
};
